/** One lot: the bundle, personal settings, media. Diligence, legal and financial
 * routes for the lot page live in their own tables. */
import type { EndpointDef } from '../endpointTypes'

export const propertyRoutes = {
  property: { method: 'GET', path: '/api/properties/:propertyId', note: 'Bundle: property, listings, media, EPC, legal packs' },
  personalSettings: { method: 'GET', path: '/api/properties/:propertyId/personal-settings' },
  patchPersonalSettings: { method: 'PATCH', path: '/api/properties/:propertyId/personal-settings', note: 'visited + expectedVisitRevision, or gdvOverridePence + expectedGdvRevision' },
  media: { method: 'GET', path: '/media', note: 'Prefix only; photo URLs come from the API and get ?variant=small|medium|full' },
} as const satisfies Record<string, EndpointDef>
